import React from "react";

export default function SearchIcon({
  className,
  size = 12,
  strokeWidth = 1.292,
  strokeOpacity = 0.42,
  ...rest
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      className={className}
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeOpacity={strokeOpacity}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      <path d="M11.146 11.146 8.613 8.613m0 0a4.667 4.667 0 1 0-6.6-6.6 4.667 4.667 0 0 0 6.6 6.6" />
    </svg>
  );
}
